var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.385 1.78c-0.8497 0-1.538 0.6888-1.538 1.538 0 0.8497 0.6888 1.538 1.538 1.538s1.538-0.6888 1.538-1.538c0-0.8497-0.6888-1.538-1.538-1.538zm-3.385 1.538c0-1.869 1.515-3.385 3.385-3.385 1.549 0 2.855 1.041 3.257 2.462h9.666c2.889 0 5.231 2.342 5.231 5.231 0 2.889-2.342 5.231-5.231 5.231h-11.08c-1.869 0-3.385 1.515-3.385 3.385s1.515 3.385 3.385 3.385h15.6l-0.8856-0.8858c-0.3605-0.3605-0.3605-0.9448 0-1.305s0.9448-0.3605 1.305 0l2.462 2.462c0.3605 0.3605 0.3605 0.9449 0 1.305l-2.462 2.462c-0.3605 0.3605-0.9448 0.3605-1.305 0s-0.3605-0.9448 0-1.305l0.8856-0.8858h-15.6c-2.889 0-5.231-2.342-5.231-5.231s2.342-5.231 5.231-5.231h11.08c1.869 0 3.385-1.515 3.385-3.385 0-1.869-1.515-3.385-3.385-3.385h-9.666c-0.4018 1.421-1.708 2.462-3.257 2.462-1.869 0-3.385-1.515-3.385-3.385z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/path.d7c1611b1e5fbe155be7f8cd7b91d0ca.svg";
export { ForwardRef as ReactComponent };